import { useLayoutEffect, useMemo, useRef, useState } from "react";
import PayStubTable from "../../../Pagat/PaySub/payStubTable/PayStubTable";
import "./ReportContent.scss";
import { useReactToPrint } from "react-to-print";
import dayjsTZ from "../../../../utils/dayjs";
import { Alert, Card, Input, message, Skeleton, Tooltip } from "antd";
import ReportTable from "./ReportTable";
import "./ReportTable.scss";
import { API } from "aws-amplify";
import { useParams } from "react-router";
import { useAuth } from "../../../../authentication/authHelpers";
import HtmlExelTabel from "../../../Konfigurimet/dynamic components/HtmlExelTabel";
import { useReportsData } from "../reportContext/reportHelpers";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { IconFilter } from "../../../../assets/icons";
import { exportToCSV } from "./export";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";
import FilterDrawer from "../../filters/FilterDrawer";
import dayjs from "dayjs";

const { TextArea } = Input;

function ReportContent({
  infos,
  page,
  onGenerate,
  contentData,
  resetCustom,
  activeFilter,
  updatingTable,
  unfilteredContentData,
}) {
  const { reportType } = useParams();
  const { userAccess } = useAuth();
  const { reportData } = useReportsData();
  const { isDarkMode } = useSelector((state) => state.usersList);

  const hasRows = !!contentData?.rowData?.length;

  const [loadData, setLoadData] = useState(false);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [content, setContent] = useState({
    note: {
      enable: false,
      content: "",
      focus: false,
    },
    title: { text: "", enable: false },
    subTitle: { text: "", enable: false },
  });
  const componentRef = useRef("payStub-print");
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: null,
    pageStyle: {
      background: "red",
    },
  });
  const excelRef = useRef("Print-Punojsit");
  const handleExcel = useReactToPrint({
    content: () => excelRef.current,
  });

  const handleUpdate = async () => {
    if (reportType && !!userAccess[0]) {
      const previousReports = await API.get("reportsLogs", `/reportsLogs`).then(
        (res) => res.filter((el) => el?.reportItem === reportType)
      );
      // console.log("PreviousReports", previousReports);
      if (previousReports.length > 0) {
        const previousReport = previousReports[0];
        if (previousReport.reportItem === reportType) {
          const updatedReport = await API.put(
            "reportsLogs",
            `/reportsLogs/${previousReport.reportId}`,
            {
              body: {
                createdBy: {
                  name: userAccess[0].given_name,
                  lastName: userAccess[0].family_name,
                  userSub: userAccess[0].userSub,
                  time: dayjsTZ().valueOf(),
                },
              },
            }
          )
            .then(() => message.success("Report updated!"))
            .catch((err) => console.log("error update", err));
        }
      } else {
        await API.post("reportsLogs", "/reportsLogs", {
          body: {
            reportItem: reportType,
            createdBy: {
              name: userAccess[0].given_name,
              lastName: userAccess[0].family_name,
              userSub: userAccess[0].userSub,
              time: dayjsTZ().valueOf(),
            },
          },
        }).then((res) => message.success("Report created!"));
      }
    }
  };

  const onPrint = () => {
    setContent((prev) => ({
      ...prev,
      title: { ...prev.title, enable: true },
      subTitle: { ...prev.subTitle, enable: true },
    }));
    setTimeout(() => {
      handlePrint();
      handleUpdate();
    }, 1000);
  };

  const excelData = useMemo(() => {
    let temp = reportData || [];

    if (
      temp?.length > 0 &&
      !!content?.note?.content &&
      content?.note?.content !== ""
    ) {
      let newElements = [];
      let newElement = {};
      Object.keys(temp[0]).forEach((colName) => {
        newElement[colName] = "";
      });
      newElements.push(newElement);
      newElements.push(newElement);
      newElements.push({ Note: "Shenimi" });
      newElements.push({ Note: content?.note?.content?.toString() });

      return [...reportData, ...newElements];
    } else {
      return reportData;
    }
  }, [reportData, content]);

  const getDate = (date, format, fallback) => {
    if (!date) return fallback || "";

    if (dayjs.isDayjs(date)) return date.format(format);

    return dayjsTZ(date).format(format);
  };

  useLayoutEffect(() => {
    if (!!page && !!infos) {
      let desired = infos[page] || null;
      if (!!desired) {
        setContent((prev) => ({
          ...prev,
          title: { ...prev.title, text: desired?.title || "" },
          subTitle: {
            ...prev.subTitle,
            text:
              desired?.subTitle +
                ` (${getDate(
                  activeFilter?.timeInterval?.[0],
                  "DD/MM/YYYY"
                )} - ${getDate(
                  activeFilter?.timeInterval?.[1],
                  "DD/MM/YYYY",
                  "NUK KENI ZGJEDHUR INTERVAL - "
                )})` || "",
          },
          note: { ...prev.note, content: desired?.note || "" },
        }));
      }
    }
  }, [page, infos, activeFilter]);

  //region RETURN
  return !contentData?.columnsDef?.length ? (
    <Alert
      type="info"
      showIcon
      style={{ width: "max-content" }}
      description={
        <span>Përdorni opsionet e mësipërme për të gjeneruar tabelën!</span>
      }
    />
  ) : (
    <div className="report-wrapper">
      <Card
        className={`${isDarkMode ? "dark" : ""}`}
        title={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              {content?.title?.text} / {content?.subTitle?.text}
            </span>
            {!!unfilteredContentData?.rowData?.length ? (
              <Tooltip title="Opsione filtrimi">
                <MondayButton
                  className="mondayButtonGrey"
                  onClick={() => setOpenFilterDrawer(true)}
                  Icon={<IconFilter />}
                />
              </Tooltip>
            ) : null}
          </div>
        }
        bordered={false}
        style={{ display: "flex", flexDirection: "column", width: "100%" }}
      >
        <div className="report" ref={componentRef}>
          {/* <div className="report-tools"> */}
          <div className="report-tools">
            <div>
              <MondayButton
                className="mondayButtonGreen"
                onClick={() =>
                  setContent((prev) => ({
                    ...prev,
                    note: {
                      ...prev.note,
                      enable: true,
                      focus: false,
                    },
                  }))
                }
              >
                {content?.note?.content !== ""
                  ? "Ndrysho shënimin"
                  : "Shkruaj shënim"}
              </MondayButton>
              {content?.note?.content !== "" ? (
                <MondayButton
                  className="mondayButtonRed"
                  onClick={() =>
                    setContent((prev) => ({
                      ...prev,
                      note: {
                        ...prev.note,
                        enable: false,
                        focus: false,
                        content: "",
                      },
                    }))
                  }
                >
                  Fshi shënimin
                </MondayButton>
              ) : null}
              {/* <span>Shkruaj titull</span>
						<span>Shkruaj Nentitull</span> */}
            </div>
            <div>
              <MondayButton
                className="mondayButtonGreen"
                onClick={() =>
                  setContent((prev) => ({
                    ...prev,
                    title: { ...prev.title, enable: false },
                  }))
                }
              >
                Ndrysho titullin
              </MondayButton>
              <MondayButton
                className="mondayButtonGreen"
                onClick={() =>
                  setContent((prev) => ({
                    ...prev,
                    subTitle: { ...prev.subTitle, enable: false },
                  }))
                }
                style={{ width: 150 }}
              >
                Ndrysho nëntitullin
              </MondayButton>
            </div>
            <div>
              <Tooltip title={!hasRows ? "Nuk ka të dhëna për të printuar" : ""}>
                <MondayButton
                  className="mondayButtonGreen"
                  onClick={onPrint}
                  disabled={!hasRows}
                >
                  Printo raportin
                </MondayButton>
              </Tooltip>

              {reportType === "approvals" ||
              reportType === "supervisorApprovals" ? (
                <>
                  <MondayButton
                    className="mondayButtonGreen print"
                    disabled={!hasRows}
                    onClick={() =>
                      exportToCSV(
                        reportData,
                        "Listë_Prezencat_",
                        activeFilter?.timeInterval,
                        content?.note?.content
                      )
                    }
                  >
                    Excel
                  </MondayButton>
                  <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="Aprovimet-homePage"
                    filename={
                      !!infos && page ? `${infos[page].title}` : "FileExcelHR"
                    }
                    sheet={
                      !!infos && page ? `${infos[page].title}` : "FileExcelHR"
                    }
                    buttonText={
                      <Tooltip
                        placement="top"
                        classNames={{ root: "global-icon-tooltip" }}
                        title={"Eksporto në Excel"}
                      >
                        <MondayButton
                          className="mondayButtonGreen print"
                          disabled={!hasRows}
                          onClick={() => {
                            setLoadData((prev) => !prev);
                          }}
                        >
                          Excel Merged
                        </MondayButton>
                      </Tooltip>
                    }
                  />
                </>
              ) : (
                <ReactHtmlTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="Aprovimet-homePage"
                  filename={
                    !!infos && page ? `${infos[page].title}` : "FileExcelHR"
                  }
                  sheet={
                    !!infos && page ? `${infos[page].title}` : "FileExcelHR"
                  }
                  buttonText={
                    <Tooltip
                      placement="top"
                      classNames={{ root: "globalPopover" }}
                      title={"Eksporto në Excel"}
                    >
                      <MondayButton
                        className="mondayButtonBlue"
                        disabled={!hasRows}
                        onClick={() => setLoadData((prev) => !prev)}
                      >
                        Excel
                      </MondayButton>
                    </Tooltip>
                  }
                />
              )}
              {/* <ExportToPdf id={"#Aprovimet-homePage"} tabelName={"aprovimet"} /> */}
            </div>
          </div>
          {!updatingTable ? (
            <div className="report-body">
              <div className="report-title">
                {" "}
                <div className="input-holder">
                  {!content.title.enable && (
                    <Input
                      autoFocus={true}
                      style={{
                        textAlign: "center",
                        fontSize: "2.9em",
                      }}
                      value={content.title.text}
                      onBlur={(e) =>
                        setContent((prev) => ({
                          ...prev,
                          title: { ...prev.title, enable: true },
                        }))
                      }
                      placeholder="Shëno titullin..."
                      onChange={(e) =>
                        setContent((prev) => ({
                          ...prev,
                          title: { ...prev.title, text: e.target.value },
                        }))
                      }
                    />
                  )}
                  {content?.title?.enable && (
                    <span
                      onClick={() =>
                        setContent((prev) => ({
                          ...prev,
                          title: { ...prev.title, enable: false },
                        }))
                      }
                    >
                      {/* <h1>{content.title.text}</h1> */}
                      <span style={{ fontSize: "2em" }}>
                        {content.title.text}
                      </span>
                    </span>
                  )}
                </div>
                <div className="input-holder">
                  {!content.subTitle.enable && (
                    <Input
                      autoFocus={true}
                      value={content.subTitle.text}
                      style={{
                        width: 400,
                        textAlign: "center",
                        fontSize: 18,
                      }}
                      onBlur={() =>
                        setContent((prev) => ({
                          ...prev,
                          subTitle: { ...prev.subTitle, enable: true },
                        }))
                      }
                      placeholder="Shëno nëntitullin..."
                      onChange={(e) =>
                        setContent((prev) => ({
                          ...prev,
                          subTitle: { ...prev.subTitle, text: e.target.value },
                        }))
                      }
                    />
                  )}
                  {content?.subTitle?.enable && (
                    <span
                      onClick={() =>
                        setContent((prev) => ({
                          ...prev,
                          subTitle: { ...prev.subTitle, enable: false },
                        }))
                      }
                    >
                      {/* <h5>{content.subTitle.text}</h5> */}
                      <span style={{ fontSize: 18 }}>
                        {content.subTitle.text}
                      </span>
                    </span>
                  )}
                </div>
              </div>
              <div>
                <ReportTable
                  columnsDef={contentData?.columnsDef || []}
                  rowData={contentData?.rowData}
                />
                <div className="page-number"></div>

                {contentData?.rowData?.length === 0 && (
                  <div>
                    <br />
                    <Alert
                      type="warning"
                      showIcon
                      description={
                        <span>
                          Për raportin e përzgjedhur, nuk ka asnjë të dhënë!
                          Ndryshoni filtrat dhe gjeneroni sërish!
                        </span>
                      }
                    />
                  </div>
                )}
              </div>
              <div className="report-notes">
                {" "}
                <br />
                {content.note.enable && !content.note.focus && (
                  <TextArea
                    autoFocus={true}
                    onBlur={() =>
                      setContent((prev) => ({
                        ...prev,
                        note: { ...prev.note, focus: true },
                      }))
                    }
                    // status={(e) => console.log(e)}
                    value={content.note.content}
                    onChange={(e) =>
                      setContent((prev) => ({
                        ...prev,
                        note: { ...prev.note, content: e.target.value },
                      }))
                    }
                    placeholder="Shkruaj një shënim"
                    autoSize={{
                      minRows: 3,
                      maxRows: 5,
                    }}
                  />
                )}
                {content.note.enable && content.note.focus && (
                  <span
                    onClick={() =>
                      setContent((prev) => ({
                        ...prev,
                        note: { ...prev.note, focus: false },
                      }))
                    }
                  >
                    {content.note.content}
                  </span>
                )}
              </div>{" "}
              <div className="reports-footer">
                {" "}
                <span style={{ fontStyle: "italic" }}>
                  Koha e gjenerimit: {dayjsTZ().format("DD/MM/YYYY HH:mm:ss")}
                </span>
              </div>
            </div>
          ) : (
            <div className="report-body">
              <Skeleton /> <Skeleton /> <Skeleton /> <Skeleton />
            </div>
          )}
        </div>{" "}
        <HtmlExelTabel
          tableData={excelData}
          loadData={loadData}
          header={!!reportData?.length > 0 ? Object.keys(reportData[0]) : []}
          // header={[
          // 	"Statusi",
          // 	"Emri",
          // 	"Mbiemri",
          // 	"Departamenti",
          // 	"Data",
          // 	"Fillimi i turnit",
          // 	"Mbarimi i turnit",
          // 	"Orët totale",
          // ]}
          id="Aprovimet-homePage"
          componentRef={excelRef}
        />
      </Card>
      {openFilterDrawer ? (
        <FilterDrawer
          {...{
            onGenerate,
            resetCustom,
            activeFilter,
            open: openFilterDrawer,
            setOpen: setOpenFilterDrawer,
            contentData: unfilteredContentData,
          }}
        />
      ) : null}
    </div>
  );
}

export default ReportContent;
